// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

/** Which kind of stored value a column of the course card holds. */
export type HoleSourceAdoptionTarget = 'card' | 'holeLength' | 'teeLength';

export type HoleSourceAdoption = {
  /** The source whose column is being made official — never "manual", which already is. */
  source: string;
  target: HoleSourceAdoptionTarget;
  /** Required for 'teeLength', meaningless otherwise. */
  teeId?: string;
};

/**
 * Makes one column of the course card official: every hole's value from that source is copied
 * into the manual row, which is what a player is shown.
 *
 * The server does the copying and decides what "official" means for each kind of value; this
 * only says which column was pressed. Resolves false on any failure — the screen re-reads the
 * course on success, so there is nothing in the answer worth parsing.
 */
export async function adoptHoleSource(
  apiBaseUrl: string,
  token: string,
  courseId: string,
  adoption: HoleSourceAdoption
): Promise<boolean> {
  try {
    const response = await fetch(
      `${apiBaseUrl}/api/geodata/courses/${encodeURIComponent(courseId)}/holes/adopt-source`,
      {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify(adoption),
      }
    );
    return response.ok;
  } catch {
    return false;
  }
}
